import { IconPhone } from '@tabler/icons-react';
import type { RidesEmergencyContactView } from '@actschurch/ccms-sdk';

/**
 * "Thandi Mokoena (wife)" plus a 48 px tap-to-call link with the number. Campus security only.
 * `align` = 'end' (default) lines it up on the right of a summary row; 'start' for lists.
 */
export function EmergencyContactLine({ contact, align = 'end' }: { contact: RidesEmergencyContactView | null | undefined; align?: 'start' | 'end' }) {
  const name = contact?.name?.trim();
  const phone = contact?.phone?.trim();
  if (!name && !phone) return null;
  const rel = contact?.relationship?.trim();
  return (
    <span style={{ display: 'inline-flex', flexWrap: 'wrap', columnGap: 8, alignItems: 'center', justifyContent: align === 'end' ? 'flex-end' : 'flex-start' }}>
      <span>{name || 'Emergency contact'}{rel ? ` (${rel.toLowerCase()})` : ''}</span>
      {phone && (
        <a
          href={`tel:${phone.replace(/[^\d+]/g, '')}`}
          aria-label={`Call ${name || 'the emergency contact'} on ${phone}`}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6, minHeight: 48, padding: '0 4px', color: 'var(--rides-primary)', fontWeight: 700, textDecoration: 'underline', textUnderlineOffset: 3 }}
        >
          <IconPhone size={16} aria-hidden="true" /> {phone}
        </a>
      )}
    </span>
  );
}
